<template>
  <div class="guess-city">
    <ModalComponentHeader> {{ messages.yourCity }} {{ userCity.UF_NAME }}? </ModalComponentHeader>
    <ModalComponentBody>
      <div class="guess-city__buttons">
        <DefButtonPrimary @click="modal.hide">
          {{ messages.yes }}
        </DefButtonPrimary>
        <DefButtonSecondary @click="handlerChoiceAnotherCity">
          {{ messages.otherCity }}
        </DefButtonSecondary>
      </div>
    </ModalComponentBody>
  </div>
</template>

<script setup lang="ts">
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import useModal from '@use/useModal/useModal';
import ChoiceCity from '@components/Cities/ChoiceCity.vue';
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import { computed } from 'vue';

import { useCitiesStore } from '@/storePinia/stores/cities';

const citiesStore = useCitiesStore();

const modal = useModal();

const messages = computed(() => citiesStore.messages);
const userCity = computed(() => citiesStore.userCity);

const handlerChoiceAnotherCity = () => {
  modal.show(ChoiceCity, {}, { width: '696px' });
};
</script>

<style lang="scss" scoped>
.guess-city {
  &__buttons {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 8px;
    @include point-md {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
  }
}
</style>
